module.exports = __webpack_public_path__ + "img/message-sp-3.07568472.jpg";